<div class="loading-window" *ngIf="!hidden">
  <div class="backdrop" *ngIf="!hidden">
    <img [src]="getLoadingIcon" alt="" />
  </div>
</div>
